const _get_active_source_from_localStorage = () => {
  const sidebarSources = localStorage.getItem("source_sidebar");
  if (!!sidebarSources) {
    return JSON.parse(localStorage.getItem("source_sidebar"));
  } else {
    return [];
  }
};
const get_section_source_id_from_local = () => {
  const user_profile = localStorage.getItem("section_inside_source_data");
  if (!!user_profile) {
    return JSON.parse(localStorage.getItem("section_inside_source_data"));
  } else {
    return [];
  }
};

const _get_user_from_localStorage = () => {
  const user_profile = localStorage.getItem("user");
  if (
    user_profile &&
    user_profile !== undefined &&
    user_profile !== "undefined" &&
    user_profile !== null
  ) {
    return JSON.parse(localStorage.getItem("user"));
  } else {
    return {};
  }
};

module.exports = {
  _get_active_source_from_localStorage,
  _get_user_from_localStorage,
  get_section_source_id_from_local,
};
